export default {
  nodes: [
		{
			id: '12',
			name: '初入职场',
		},
    {
      id: '1',
      name: '设备技术员',
      conf: [],
    },
    {
      id: '2',
      name: '电气技术员',
      conf: [],
    },
    {
      id: '3',
      name: '工艺技术员',
      conf: [],
    },
    {
      id: '4',
      name: '其他技术岗',
      conf: [],
    },
    {
      id: '5',
      name: '初级技术员',
      conf: [],
    },
    {
      id: '6',
      name: '中级工程师',
      conf: [],
    },
    {
      id: '7',
      name: '高级工程师',
      conf: [],
    },
    {
      id: '8',
      name: '技术经理',
      conf: [],
    },
    {
      id: '9',
      name: '技术总监',
      conf: [],
    },
    {
      id: '10',
      name: '研发经理',
      conf: [],
    },
    {
      id: '11',
      name: '研发总监',
      conf: [],
    },
  ],
  edges: [
    {
      source: '12',
      target: '1',
    },
    {
      source: '12',
      target: '2',
    },
    {
      source: '12',
      target: '3',
    },
    {
      source: '12',
      target: '4',
    },
    {
      source: '1',
      target: '5',
    },
    {
      source: '2',
      target: '5',
    },
    {
      source: '3',
      target: '5',
    },
    {
      source: '4',
      target: '5',
    },
    {
      source: '5',
      target: '6',
    },
    {
      source: '6',
      target: '7',
    },
    {
      source: '7',
      target: '8',
    },
    {
      source: '7',
      target: '10',
    },
    {
      source: '8',
      target: '9',
    },
    {
      source: '10',
      target: '11',
    }
  ]
}